import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'linkedin-third-party-glyph-icon'

export function LinkedInSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path
        fill="current"
        fillRule="evenodd"
        d="M9.205 22.5h3.429V12.041H9.205V22.5ZM10.943 7C9.768 7 9 7.782 9 8.807c0 1.005.746 1.808 1.895 1.808h.026c1.194 0 1.94-.803 1.94-1.808C12.839 7.782 12.115 7 10.943 7ZM25 16.503V22.5h-3.431v-5.596c0-1.405-.497-2.365-1.735-2.365-.949 0-1.51.647-1.76 1.273-.088.224-.114.536-.114.848v5.84h-3.43s.05-9.475 0-10.459h3.43v1.483c-.005.012-.014.023-.022.034h.022v-.034c.455-.71 1.27-1.729 3.09-1.729 2.257 0 3.95 1.496 3.95 4.708Z"
        clipRule="evenodd"
      />
    </symbol>
  )
}

const LinkedInStandaloneContent = standalone(LinkedInSymbol, ID)

export const Linkedin = styled(function LinkedInStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-linkedin">
      <LinkedInStandaloneContent />
    </Icon>
  )
})``

export const LinkedInLightweight = styled(function LinkedInComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-linkedin">
      {lightweight(ID)}
    </Icon>
  )
})``
